/**
 * Errores de red en español claro.
 *
 * El navegador entrega mensajes crudos e inútiles para el usuario final
 * ("Failed to fetch" en Chrome, "Load failed" en Safari, "NetworkError when
 * attempting to fetch resource" en Firefox, "The operation was aborted"). Estos
 * helpers los traducen a algo accionable. Pensado para el flujo móvil de
 * subidas del aseador, pero sirve a cualquier consumidor.
 */

/** Mensajes crudos del navegador que significan "no hubo respuesta del servidor". */
const PATRON_RED =
  /failed to fetch|load failed|networkerror|network request failed|network error|err_internet|err_network|the internet connection appears to be offline|fetch failed/i;

/** ¿Es un corte de conexión (TypeError de fetch, XHR onerror/ontimeout)? */
export function esErrorDeRed(e: unknown): boolean {
  if (e instanceof TypeError) return true;
  const msg = e instanceof Error ? e.message : typeof e === "string" ? e : "";
  return PATRON_RED.test(msg);
}

/** ¿La operación fue cancelada a propósito (AbortController / xhr.abort)? */
export function esCancelacion(e: unknown): boolean {
  if (e && typeof e === "object") {
    const name = (e as { name?: string }).name;
    if (name === "AbortError") return true;
    if ((e as { codigo?: string }).codigo === "CANCELADA") return true;
  }
  return false;
}

export const MSG_SIN_CONEXION =
  "Se perdió la conexión. Revisa tu internet y vuelve a intentarlo.";

export const MSG_SUBIDA_SIN_CONEXION =
  "Se perdió la conexión; el archivo no se terminó de subir. Toca Reintentar.";

export const MSG_CANCELADA = "Subida cancelada.";

/**
 * Traduce cualquier error a un mensaje en español para mostrar al usuario.
 * Los errores que ya traen un mensaje legible (los del servidor) se respetan.
 */
export function mensajeErrorRed(e: unknown, porDefecto = "No se pudo completar la operación."): string {
  if (esCancelacion(e)) return MSG_CANCELADA;
  if (esErrorDeRed(e)) {
    if (typeof navigator !== "undefined" && navigator.onLine === false) {
      return "Sin conexión a internet. Se retomará cuando vuelva la señal.";
    }
    return MSG_SIN_CONEXION;
  }
  if (e instanceof Error && e.message) return e.message;
  if (typeof e === "string" && e) return e;
  return porDefecto;
}
